import React from "react";
import styled from "@emotion/styled";
export default function VideoLeft() {
  return <div>VideoLeft</div>;
}
